import React from 'react';

import { Description as DescriptionIcon, Loop as LoopIcon } from "@mui/icons-material";

import StandardTooltip from "@root/Components/StandardTooltip";

const IdCell = (props) => {
    return (
        <div className="grid-x">
            <div className="cell small-8"
                style={{
                    textDecoration: (props.row.hasOwnProperty('archived_at') && props.row.archived_at !== null)
                        ? 'line-through' : 'inherit'
                }}
            >
                { props.row.slug }
            </div>

            <div className="cell small-4 text-right">
                { props.row.recurrence_id &&
                    <span>
                        <LoopIcon style={{ fontSize: '1em' }} />
                    </span>
                }
                { props.row.notes &&
                    <StandardTooltip
                        title={<>
                            <div><strong>Notes</strong></div>
                            <div>{props.row.notes}</div>
                        </>}
                    >
                        <span>
                            <DescriptionIcon style={{ fontSize: '1em' }} />
                        </span>
                    </StandardTooltip>
                }
            </div>
        </div>
    );
}

export default IdCell;
